import {
    AppBar,
    Avatar,
    Box,
    Divider,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    SvgIcon,
    Toolbar,
    Typography
} from "@mui/material";
import {SymblLogoGradient} from "../icons/SymblLogo";
import {GradientButton, GradientText} from "./GradientComponents";
import MediumSimpleLockIcon from "../icons/MediumSimpleLockIcon";
import MediumBookOpenIcon from "../icons/MediumBookOpenIcon";
import {useAuth0} from "@auth0/auth0-react";
import React, {useState} from "react";
import PartneringInterestModal from "./PartneringInterestModal";

const SymblAppBar = () => {
    const {user, isAuthenticated, logout} = useAuth0();
    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
    const [partnershipOpen, setPartnershipOpen] = useState(false);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar position={"static"} style={{
            backgroundColor: '#fff',
            zIndex: 1000,
            boxShadow: '0px 1px 2px 0px #0F1A2A14',
            border: '0px 0px 1px 0px'

        }}>
            <Toolbar disableGutters style={{display: "flex", justifyContent: "space-between"}} sx={{ml: 4, mr: 4}}>
                <Box style={{
                    alignItems: 'center',
                    display: 'flex'}}
                     flexDirection={"row"}>
                    <SymblLogoGradient/>
                    <Divider orientation={"vertical"} flexItem sx={{mx: 2}} style={{height: 40}}/>
                    <GradientText variant={"body1"} style={{fontWeight: 400}}>Nebula Playground</GradientText>
                </Box>
                <Box style={{display: "flex", gap: "12px"}}>
                            <GradientButton onClick={() => {
                                setPartnershipOpen(true)
                            }}
                                style={{borderRadius: 999}}
                                            sx={{px: 2, py: 2}}
                            >
                                <GradientText variant={"body2"}>Become a Partner</GradientText>
                            </GradientButton>
                            <a href={"https://docs.symbl.ai/docs/model-api"} target="_blank">
                                <GradientButton style={{borderRadius: 999}}
                                                sx={{px: 2, py: 2}}
                                                startIcon={<MediumBookOpenIcon/>}>
                                    <GradientText variant={"body2"}>Learn more about Nebula</GradientText>
                                </GradientButton>
                            </a>
                            <IconButton onClick={handleOpenUserMenu} style={{padding: 0}}>
                                <Avatar src={user && user.picture}
                                        alt={user && user.name}
                                />
                                {/*<Typography variant={"body2"}>{user && user.name}</Typography>*/}
                            </IconButton>
                            <Menu
                                sx={{mt: '45px'}}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem onClick={() => logout()}>Logout</MenuItem>
                            </Menu>
                </Box>
            </Toolbar>
            {partnershipOpen && (<PartneringInterestModal email={user && user.email || ''} open={partnershipOpen} onClose={() => setPartnershipOpen(false)}/>) }
        </AppBar>
    );
};

export default SymblAppBar;
